import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import { Breadcrumb } from "react-bootstrap";
import FeedbackQuestionLayer from "./FeedbackQuestionLayer";


const FeedbackQuestionPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Feedback Questions" />

        {/* FloorMapLayer */}
        <FeedbackQuestionLayer />
      </MasterLayout>
    </>
  );
};

export default FeedbackQuestionPage;
